import { CardBody } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { CardHeightWrapper } from '../card/CardHeightWrapper';

export const EventInsightsEmpty = () => {
  const { t } = useTranslation('visualisation');
  return (
    <CardHeightWrapper>
      <CardBody statusType="info" statusTitle={t('noInsightsTitle')} statusDescription={t('noInsightsDescription')} />
    </CardHeightWrapper>
  );
};
